/**
 * GondolaPaddleIllustration/index.js
 * desc: gondola paddle illustration
 * note: stateless presentational component
 */
'use strict';

import { classNames } from '../../../utilities';
import './styles.css';


const GondolaPaddleIllustration = ({ className }) => {
    const classList = classNames('gondola-paddle illustration', className);

    return (
        <figure className={ classList } >
            <svg viewBox="0 0 235 248" xmlns="http://www.w3.org/2000/svg"><path d="M232.969 1.471a1.844 1.844 0 00-2.043-.284 1.86 1.86 0 00-.577.438L6.589 246.838h9.685L233.123 4.083a1.858 1.858 0 00-.154-2.612z"/><path className="wave" d="M0 246.908h36.384"/><path className="wave" d="M43.573 246.908h13.292"/></svg>
        </figure>
    );
};


export default GondolaPaddleIllustration;
